export default __webpack_public_path__ + "static/media/DSC00534.97a1d352.JPG";